// Puerto del dominio (repository abstracto) para crear/consultar la cotización final.
import { Observable } from 'rxjs';
import { CreateCotizacionInput, CotizacionResult } from '../../interfaces/cotizacion/cotizacion.interface';

export abstract class CotizacionRepository {
  abstract create(input: CreateCotizacionInput): Observable<CotizacionResult>;
  abstract getByQuoteId(quoteId: string): Observable<CotizacionResult>;
}
